export default __webpack_public_path__ + "static/media/custom1w.0da57e9b.png";